// extracted by mini-css-extract-plugin
module.exports = {"container":"ReviewItem_container__2UNGl","text":"ReviewItem_text__Ya6nF","btn":"ReviewItem_btn__1XPzS"};